<!-- Display existing image from imageId -->
<ng-container *ngIf="hasExistingImage">
	<ws-img [imageId]="imageId"></ws-img>
	<ws-button
		styleClass="list-action-button no-button"
		matIcon="delete"
		type="button"
		(click)="deleteExistingImage()"
	></ws-button>
</ng-container>

<!-- Display selected file preview -->
<ng-container *ngIf="!!selectedFile && showSelectedImage">
	<ws-img [imageFile]="selectedFile"></ws-img>
	<ws-button
		styleClass="list-action-button no-button"
		matIcon="delete"
		type="button"
		(click)="resetSelection()"
	></ws-button>
</ng-container>

<!-- Upload form -->
<ng-container *ngIf="showUploadForm">
	<button
		type="button"
		class="upload-container"
		[class.has-background]="!!backgroundImage"
		[style.background-image]="backgroundImage ? 'url(' + backgroundImage + ')' : null"
		(click)="fileInput.click()"
		[disabled]="uploading"
	>
		<div class="upload-content">
			<mat-icon>upload_file</mat-icon>
			<div translate="_ws-framework.image.upload"></div>
			<div translate="_ws-framework.image.filetypes"></div>
		</div>
		<input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" />
	</button>
</ng-container>
